import React from 'react';

const ShoppingCartQuickViewContext = React.createContext({
    /* Default Shopping Cart Quick View State */
});

export default ShoppingCartQuickViewContext;
